{
  "titel": "Interviews mit dem Landesrabbiner Kadnykov",
  "seitentitel": "Besuch Landesrabbiner Yuriy Kadnykov in Greifswald – Schüler*innen stellen Fragen",
  "vorschaubild": "img/interviews/preview.webp",
  "vorschautext": "Der Landesrabbiner Yuriy Kadnykov war zu Gast im Medienzentrum Greifswald und stellte sich den Fragen der Schüler*innen der IGS „Erwin Fischer“. Sein Besuch ermöglichte es, nicht nur über die Geschichte des Judentums zu sprechen, sondern auch einen direkten Einblick in gelebtes jüdisches Leben und den Beruf eines Rabbiners zu gewinnen.",
  "einleitung": "In vier Teilen beantwortet Landesrabbiner Yuriy Kadnykov die Fragen der Schüler*innen zu verschiedenen Aspekten des jüdischen Lebens, seiner Arbeit als Rabbiner und zur Bedeutung von Erinnerungskultur.",
  "kapitel_intro": "Klicken Sie auf die Frage, um direkt zur entsprechenden Stelle im Video zu springen.",
  "videos": [
    {
      "id": 1,
      "titel": "Rabbiner als Beruf",
      "video_src": "videos/interviews/interview-01.mp4",
      "video_poster": "img/interviews/interview-01-poster.webp",
      "beschreibung": "In diesem Gespräch dreht sich alles um das jüdische Alltags- und Gemeindeleben – Rabbineramt, Schule & Religion, jüdische Regeln.",
      "dauer": "8:45",
      "kapitel": [
        { "zeit": 0, "label": "Wie ist es Rabbiner zu sein?" },
        { "zeit": 27, "label": "Wie viele Rabbiner gibt es in Deutschland?" },
        { "zeit": 62, "label": "Wo gehen jüdische Kinder zur Schule oder gibt es bestimmte Schulen?" },
        { "zeit": 87, "label": "Was unterscheidet einen Rabbiner von einem Pastor?" },
        { "zeit": 130, "label": "Welche Getreidearten kann man essen?" },
        { "zeit": 187, "label": "Spielt Homosexualität eine Rolle im Judentum?" }
      ]
    },
    {
      "id": 2,
      "titel": "Das Leben eines Rabbiners",
      "video_src": "videos/interviews/interview-02.mp4",
      "video_poster": "img/interviews/interview-02-poster.webp",
      "beschreibung": "Dieses Interview beleuchtet den persönlichen Werdegang des Landesrabbiners – Berufung, Biografie, Glaubensweg.",
      "dauer": "12:20",
      "kapitel": [
        { "zeit": 0, "label": "Wieso wollten Sie Landesrabbiner werden?" },
        { "zeit": 124, "label": "Was haben Sie in der Zeit als Landesrabbiner gelernt?" },
        { "zeit": 199, "label": "Wie sind Sie in Russland aufgewachsen?" },
        { "zeit": 305, "label": "Von welcher Stadt kamen Sie her?" },
        { "zeit": 382, "label": "Was halten Sie von anderen Religionen?" },
        { "zeit": 504, "label": "Wie haben Sie zum Judentum gefunden?" },
        { "zeit": 682, "label": "Haben Sie mit dem Militär Kontakt gehabt bzw. gedient?" }
      ]
    },
    {
      "id": 3,
      "titel": "Die Freizeit eines Rabbiners",
      "video_src": "videos/interviews/interview-03.mp4",
      "video_poster": "img/interviews/interview-03-poster.webp",
      "beschreibung": "Hier steht das private Umfeld und der Berufsalltag des Rabbiners im Mittelpunkt – Familie, Traditionen, Arbeitsleben.",
      "dauer": "4:04",
      "kapitel": [
        { "zeit": 0, "label": "Gibt es in Ihrer Familie Mitglieder, die nicht jüdisch sind?" },
        { "zeit": 34, "label": "Haben Sie auch jüdische Deko in Ihrem Haus?" },
        { "zeit": 72, "label": "Was gibt es für Regeln als Rabbiner?" },
        { "zeit": 109, "label": "Haben Sie viel Freizeit als Rabbiner?" },
        { "zeit": 133, "label": "Was haben Sie gemacht bevor Sie Rabbiner geworden sind?" },
        { "zeit": 178, "label": "Würden Sie auch einen anderen Beruf machen?" }
      ]
    },
    {
      "id": 4,
      "titel": "Interview in russischer Sprache",
      "video_src": "videos/interviews/interview-04.mp4",
      "video_poster": "img/interviews/interview-04-poster.webp",
      "beschreibung": "In diesem Interview werden religiöse Sichtweisen und das Leben jüdischer Menschen außerhalb Israels thematisiert – Gebote, Identität, Diaspora. Es wurde auf russisch geführt und beinhaltet deutsche Untertitel.",
      "dauer": "2:12",
      "kapitel": [
        { "zeit": 0, "label": "Welches Gebot erscheint Ihnen am seltsamsten oder unerwartetsten?" },
        { "zeit": 60, "label": "Was bedeutet es Jude außerhalb von Israel zu sein – geht es dabei mehr um Religion, Kultur, Geschichte oder etwas anderes?" }
      ]
    }
  ]
}
